import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import SnapstyrAddCom from './SnapstyrComs/SnapstyrAdd';
import { Url } from '../../../common/constants';

const SnapstyrAdd = (props) => {
  const containerRef = React.createRef();

  return (
    <div className="container-fluid" ref={containerRef} style={{ height: '100dvh', overflowY: 'auto' }}>
      <div className="row">
        <div className="col-12 px-2 px-lg-3">
          <SnapstyrAddCom
            open
            onClose={() => props.history.push(Url.Snapstyr.replace(':pageId', props.page.id))}
            onComplete={() => props.history.push(Url.Snapstyr.replace(':pageId', props.page.id))}
            onScrollToTop={() => {
              if (containerRef.current) {
                setTimeout(() => {
                  containerRef.current.scrollTo({ top: 0 });
                }, 100);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  page: state.page.selected,
});

SnapstyrAdd.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  page: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, null)(SnapstyrAdd);
